/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import React from "react"
import { hydrate, render } from "react-dom"
import Layout from "./src/Layout/Layout"
import "./src/Digiflow/scss/main.scss"
import Scripts from "./src/Layout/Scripts"
import { CwvProvider } from "./src/context/context"

export const wrapPageElement = ({ element }) => {
  return (
    <>
      <Scripts />
      <CwvProvider>
        <Layout>{element}</Layout>
      </CwvProvider>
    </>
  )
}

export const replaceHydrateFunction = () => (element, container) => {
  const shouldHydrate = container.hasChildNodes()
  if (shouldHydrate) {
    hydrate(element, container)
  } else {
    render(element, container)
  }
}
